import { useState, useEffect } from 'react';
import useDataBean from '../../../../../../core/services/dataBean/useDataBean';
import { _EmployeeContract } from '../../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import Select from 'react-select';


interface Props {
    entity?: number,
    idSelector: number;
    onChange: any;
    label?: string;
}

export const WelfareEntitySelector = ({ entity, idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_EmployeeContract)
    const [selectedOption, setSelectedOption] = useState<any>(null);

    // public final static int EPS = 0;
    // public final static int ARP = 1;
    // public final static int CCF = 2;
    // public final static int AFP = 3;
    // public final static int SENA = 4;
    // public final static int ICBF = 5;
    // public final static int SOLIDARY_AFP = 6;
    // public final static int SUBSISTENCE_AFP = 7;
    // public final static int OTHERS = 8;
    // public final static int FCE = 9;
    // public final static int COOPERATIVE = 10;

    useEffect(() => {
        getLista();
    }, [entity])

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.DataBeanProperties.IDWelfareEntity === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.DataBeanProperties.IDWelfareEntity,
                    label: `${found.DataBeanProperties.Code} - ${found.DataBeanProperties.AccountName}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);


    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(null);
        } else {

            if (onChange) {
                onChange(option.value);
            }
        }
    };

    const getLista = () => {
        instance.getWelfareEntityCatalogByType(entity).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { toast.error(err) })
    }

    const options = lista.map((item: any) => ({
        value: item.DataBeanProperties.IDWelfareEntity,
        label: `${item.DataBeanProperties.Code} - ${item.DataBeanProperties.AccountName}`,
        item: item
    }));

    return (
        <div>
            {label && label != " " &&
                < label > {label ?? "Entidad"}</label>
            }
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder={`Selecciona un ${label}...`}
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
}